/**
 * Copyright © 2026 Adnuntius AS.
 */
import {WritableSignal} from '@angular/core';

/** True for Angular WritableSignal (callable + .set). */
export function isViewSignal(value: any): value is WritableSignal<any> {
  return typeof value === 'function' && typeof value.set === 'function';
}

/** Read a signal or plain property from a ctrl-style host. */
export function readViewSignal<T>(host: any, key: string): T {
  const value = host[key];
  return (isViewSignal(value) ? value() : value) as T;
}

/**
 * Write view state. Sync set is fine after AdnHttp settle; use defer=true when
 * writing during an existing CD turn (legacy afterInit / product hydrate).
 *
 * On phased edit pages, prefer `editPhase.viewWrite` instead.
 */
export function writeViewSignal<T>(host: any, key: string, next: T, defer = false): void {
  const value = host[key];
  if (!isViewSignal(value)) {
    if (defer) {
      setTimeout(() => {
        host[key] = next;
      }, 0);
      return;
    }
    host[key] = next;
    return;
  }
  if (defer) {
    setTimeout(() => {
      value.set(next);
    }, 0);
    return;
  }
  value.set(next);
}
